import { createTheme } from "@mui/material"

export const liveDrawTheme = createTheme({
  typography: {
    fontFamily: "Nunito, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          padding: "3px 12px",
        },
      },
    },
  },
})
